import React from 'react';

import { CardWrapper } from '../../components/CardWrapper/CardWrapper';
import Strings from '../../Strings';
import { activateChatwootSupportPage, deactivateChatwootSupportPage } from '../../utils/chatwoot';
import styles from './support.module.scss';

function Support() {
  const buildDate = process.env.BUILD_DATE
    ? new Date(process.env.BUILD_DATE).toLocaleString()
    : 'Unknown';

  React.useEffect(() => {
    activateChatwootSupportPage();

    return () => {
      deactivateChatwootSupportPage();
    };
  }, []);

  return (
    <CardWrapper title={Strings.supportHeader}>
      <React.Fragment>
        <div className={styles.title}>{Strings.supportSubHeader}</div>
        <div className={styles.text}>
          {Strings.supportText}
          <a href={`mailto:${Strings.supportEmail}?subject=${Strings.emailSubject}`}>{Strings.supportEmail}</a>
        </div>
        <a href={`mailto:${Strings.supportEmail}?subject=${Strings.emailSubject}`} className={styles.button}>
          {Strings.supportButton}
        </a>
        <div className={styles.buildInfo}>
          <div className={styles.buildInfoTitle}>Build Information</div>
          <div className={styles.buildInfoItem}>
            <span>Branch:</span> {process.env.GIT_BRANCH || 'Unknown'}
          </div>
          <div className={styles.buildInfoItem}>
            <span>Commit:</span> {process.env.GIT_HASH || 'Unknown'}
          </div>
          {process.env.GIT_TAG && (
            <div className={styles.buildInfoItem}>
              <span>Tag:</span> {process.env.GIT_TAG}
            </div>
          )}
          <div className={styles.buildInfoItem}>
            <span>Built:</span> {buildDate}
          </div>
        </div>
      </React.Fragment>
    </CardWrapper>
  );
}

export default Support;
